import MoveAndRotate from "./moveAndRotate";

class MoveVolume extends MoveAndRotate {
    branchId;
    volumeName;
    animateMovement;
    animateTime;

    constructor(props) {
        super(props);
        this.branchId = props.volume?.id;
        this.volumeName = props.volume?.name;
        this.animateMovement = props.animateMovement;
        this.animateTime = props.animateTime;
    }

    async stop() {
        CADModelTransformationAnimationManager.completeAndRemoveCurrentAnimationOfThisVolume(this.branchId);
    }

    async execute() {
        const volumeFinalMatrix = this.getComposedMatrix();
        AnimationPlayer.stopConflictingMeshAnimations(AnimationPlayer.meshType.TREE, this.branchId);

        if (this.animateMovement === undefined) {
            this.animateMovement = true;
        }
        if (!this.animateTime) {
            this.animateTime = 2000;
        }

        moveVolume(modelManager.getVolume(this.branchId), volumeFinalMatrix, this.animateMovement, this.animateTime, !!this.transitionValues, false);
    }
}

export default MoveVolume;
